import { createPlatePlugin } from '@udecode/plate-core/react';

import { useCypressAdapter } from './use-cypress-adapter';

export const CypressPlugin = createPlatePlugin({
  key: 'CypressPlugin',
  useHooks: useCypressAdapter,
});
